import { useMemo } from "react";
import { convertTimeZoneToString } from "src/utils/convert-time-zone-to-string";
import { tzOffset } from "@date-fns/tz";

export const useTimeZonesSelectData = () => {
  const selectTimezoneData = useMemo(() => {
    const timezones = Intl.supportedValuesOf("timeZone");

    const list = timezones
      .map(tz => {
        return {
          label: convertTimeZoneToString(tz),
          value: tz,
          offset: tzOffset(tz, new Date()),
        };
      })
      .sort((a, b) => a.offset - b.offset);

    return list;
  }, []);

  return selectTimezoneData;
};
